// Gorgias Chat - Load Only on User Interaction
(function() {
  const isMobile = window.innerWidth <= 768;
  let gorgiasLoaded = false;
  
  function loadGorgias() {
    if (gorgiasLoaded) return;
    gorgiasLoaded = true;
    
    // Load Gorgias Chat Widget
    const chatScript = document.createElement('script');
    chatScript.id = 'gorgias-chat-widget-install-v3';
    chatScript.src = 'https://config.gorgias.chat/bundle-loader/01J2A040VWHN6AJWD2TWRFPV4J';
    chatScript.async = true;
    document.body.appendChild(chatScript);
    
    // Load Bundle script
    const bundleScript = document.createElement('script');
    bundleScript.src = 'https://assets.9gtb.com/loader.js?g_cvt_id=eb77a0d1-cde1-4a5e-9625-add5aff0f490';
    bundleScript.async = true;
    document.body.appendChild(bundleScript);
    
    // Remove all event listeners after loading
    window.removeEventListener('scroll', loadGorgias);
    window.removeEventListener('touchstart', loadGorgias);
    window.removeEventListener('mousemove', loadGorgias);
    window.removeEventListener('click', loadGorgias);
  }
  
  // Wait for page to fully load first
  if (document.readyState === 'complete') {
    attachListeners();
  } else {
    window.addEventListener('load', attachListeners);
  }
  
  function attachListeners() {
    if (isMobile) {
      // Mobile: Load only on scroll or touch
      window.addEventListener('scroll', loadGorgias, { once: true, passive: true });
      window.addEventListener('touchstart', loadGorgias, { once: true, passive: true });
    } else {
      // Desktop: Load on scroll, mousemove, or click
      window.addEventListener('scroll', loadGorgias, { once: true, passive: true });
      window.addEventListener('mousemove', loadGorgias, { once: true, passive: true });
      window.addEventListener('click', loadGorgias, { once: true, passive: true });
    }
  }
})();

